<template>
    <div class="table-responsive">
        <table :class="['table', 'table-striped', 'table-fixed', hasBorder ? 'table-bordered' : '']">
            <thead>
                <tr>
                    <th v-if="hasCheckbox" width="60px">
                        <slot name="th-checkbox"></slot>
                    </th>
                    <th v-for="column in columns" :style="{width: column.width ?? ''}">
                        <slot :name="`th-${column.key}`" :column="column">{{ column.name }}</slot>
                    </th>
                </tr>
            </thead>
            <tbody>
                <slot name="table-body"></slot>
                <tr v-for="row in rows">
                    <td v-if="hasCheckbox">
                        <slot name="td-checkbox" :row="row"></slot>
                    </td>
                    <td v-for="column in columns" :style="{
                        verticalAlign: column.verticalAlign ?? 'middle'
                    }">
                        <slot :name="`td-${column.key}`" :column="column" :row="row">{{ row[column.key] ?? '' }}</slot>
                    </td>
                </tr>
            </tbody>
            <tfoot v-if="hasTfoot">
                <slot name="tfoot"></slot>
            </tfoot>
        </table>
    </div>
</template>

<script>
export default {
    name: 'TableComponent',
    props: ['columns', 'rows', 'orders', 'hasBorder'],
    computed: {
        hasTfoot() {
            return !!this.$slots.tfoot
        },
        hasCheckbox() {
            return !!this.$slots['th-checkbox'] && !!this.$slots['td-checkbox']
        }
    }
}
</script>
